import { EditIcon } from "@chakra-ui/icons";
import { Box, Button, Container, Flex, Spacer, Text, Image, Heading, Divider, SimpleGrid, Grid, GridItem, ButtonGroup, IconButton, AspectRatio, useDisclosure } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoadingScreen from "components/loading-screen";
import Layout from "scenes/layouts";
import ShortenLinkService from "../../services/shorten/shortenlink-service";
import Clipboard from "components/clipboard";
import AppConsts from "../../libs/appconst";
import Number from "components/number-format";
import BannerService from "../../services/banners/banner-service";
import { BsImage } from "react-icons/bs";
import EditImageDialog from "../../components/edit-image-dialog";
import LogosNotification from "../../utils/notification-utils";
import ConfirmDialog from "../../components/confirm-dialog";
import AuthorService from "../../services/authors/author-service";

const AuthorDetailScene = (): ReactElement => {
    const navigate = useNavigate();
    const { authorId } = useParams();
    const [isLoading, setLoading] = useState<boolean>(true);
    const [author, setAuthor] = useState<any>(null);
    const { isOpen: isShowChangeImageDialog, onOpen: onShowChangeImageDialog, onClose: onCloseChangeImageDialog } = useDisclosure();
    const { isOpen: isShowDeleteDialog, onOpen: onShowDeleteDialog, onClose: onCloseDeleteDialog } = useDisclosure();
    const [isDeleting, setIsDeleting] = useState<boolean>(false);

    useEffect(() => {
        setLoading(true);
        AuthorService.Get(authorId).then((res: any) => {
            setAuthor(res.result);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    const handleChangeImage = (imageData: any, finallyFunction: any) => {
        AuthorService.ChangeImage(authorId, imageData).then((res: any) => {
            onCloseChangeImageDialog();
            setAuthor(res.result);
            LogosNotification.Success("Gambar Author telah berhasil diperbaharui.");
            window.location.reload();
        }).finally(() => {
            finallyFunction();
        });
    };

    const handleDeleteAuthor = () => {
        setIsDeleting(true);
        AuthorService.Delete(authorId).then((res: any) => {
            LogosNotification.Success("Author telah berhasil dihapuskan.");
            navigate("/authors");
        }).finally(() => {
            setIsDeleting(false);
        });
    };

    if (isLoading)
        return (<LoadingScreen />)

    return (
        <Layout>
            <Container maxWidth={"8xl"} pt={10}>
                <Box>
                    <Flex>
                        <Text fontSize={{ base: '2xl', md: '3xl' }} fontWeight={"bold"}>Author {author.name}</Text>
                        <Spacer />
                        <Button ml={2} variant={"outline"} onClick={() => { navigate(`/authors/${authorId}/edit`) }}>Edit Author</Button>
                    </Flex>
                    <Box rounded={'lg'} borderWidth={1} p={8}>
                        <Box>
                            <AspectRatio maxW='300px' ratio={1} flex={"1 1 auto"}>
                                <Box borderRadius={"md"}>
                                    <Image src={author.imageUrl} objectFit='cover' />
                                </Box>
                            </AspectRatio>
                            <IconButton
                                variant={"solid"}
                                colorScheme={'teal'}
                                isRound={true}
                                position={'relative'} bottom={45} ml={1} mb={1}
                                aria-label='Ubah Gambar Author'
                                icon={<BsImage />}
                                style={{ zIndex: 1 }}
                                onClick={onShowChangeImageDialog}
                            />
                            {
                                isShowChangeImageDialog &&
                                <EditImageDialog onClose={onCloseChangeImageDialog} title="Ubah Gambar Author" onSubmit={handleChangeImage} aspectRatio={1} helperText={"Ukuran: 875 x 875 px"} />
                            }

                            <Box pt={0} pb={2} flex={1}>
                                <Text fontSize={'sm'} color={'gray.500'}>Nama</Text>
                                <Text fontSize={'sm'} fontWeight={'bold'}>{author.name || '-'}</Text>
                            </Box>
                            <Box py={2} flex={1}>
                                <Text fontSize={'sm'}>Profesi</Text>
                                <Text fontSize={'sm'} fontWeight={'bold'}>{author.shortBioData || '-'}</Text>
                            </Box>
                            <Box py={2} flex={1}>
                                <Text fontSize={'sm'}>Status</Text>
                                <Text fontWeight={'bold'} color={author.status == 0 ? "green.600" : "red.500"}>{author.status == 0 ? "Aktif" : "Tidak Aktif"}</Text>
                            </Box>
                            <Box py={2} flex={1}>
                                <Text fontSize={'sm'}>Tentang {author.name}</Text>
                                <Box className='logos-quill' dangerouslySetInnerHTML={{ __html: author.about }}></Box>
                            </Box>
                        </Box>

                        <Divider my={5} />

                        <Box>
                            <ButtonGroup gap={2}>
                                <Button onClick={() => navigate(`/authors/${authorId}/edit`)}>Edit</Button>
                                <Button variant={'outline'} colorScheme={'red'} isLoading={isDeleting} onClick={onShowDeleteDialog}>Hapus</Button>
                                <Button variant={'outline'} onClick={() => { navigate('/authors') }}>Kembali</Button>
                            </ButtonGroup>
                        </Box>
                        {
                            isShowDeleteDialog &&
                            <ConfirmDialog
                                title={'Hapus Author'}
                                message={`Apakah Anda yakin untuk menghapus Author ${author.name}?`}
                                colorScheme={'red'}
                                buttonLabel={'Yakin'}
                                onSubmit={handleDeleteAuthor}
                                onClose={onCloseDeleteDialog}
                                isLoading={isDeleting}
                            />
                        }
                    </Box>
                </Box>
            </Container>
        </Layout >
    );
};

export default AuthorDetailScene;